import store from "store";
import { USER_ROLES, LINKS } from "../constants";
import api from "api";
import { logger } from "utils/logger";

// TODO fix store

export const urlsToTrack = {
  [LINKS.home]: "home",
  [LINKS.pricing]: "pricing",
  [LINKS.useCases]: "use_cases",
  [LINKS.helpVideo]: "help_video",
  [LINKS.auditionVoices]: "audition_voices",
  [LINKS.chooseVoices]: "choose_voices",
  [LINKS.account]: "account",
  [LINKS.calibrations]: "calibrations_list",
  [LINKS.faq]: "faq",
  [LINKS.login]: "login",
  [LINKS.signup]: "signup",
  [LINKS.forgotPassword]: "forgot_password",
  [LINKS.termsOfUse]: "terms",
  [LINKS.acceptableUsePolicy]: "acceptable_use_policy",
  [LINKS.account]: "personal_info",
  [LINKS.plan]: "subscription",
  [LINKS.statistics]: "statistics",
  [LINKS.createCalibration]: "new_calibration",
  [LINKS.createRecording]: "new_original",
  project: "project",
  [LINKS.unverified]: "unverified",
  [LINKS.verifyEmail]: "verify_email",
  [LINKS.voiceTalents]: "voice_talents",
};

export const EVENTS = {
  ACCENT_CHANGE: "ACCENT_CHANGE",
  ADD_MORE_VOICES: "ADD_MORE_VOICES",
  ADD_VOICES_CTA: "ADD_VOICES_CTA",
  BTB_CTA: "BTB_CTA",
  CALIBRATION_DOWNLOAD: "CALIBRATION_DOWNLOAD",
  CALIBRATION_INVALID_INPUT: "CALIBRATION_INVALID_INPUT",
  CHANGE_CALIBRATION: "CHANGE_CALIBRATION",
  CHANGE_MIC: "CHANGE_MIC",
  CHOOSE_VOICES_CTA: "CHOOSE_VOICES_CTA",
  CONVERSION_TAB: "CONVERSION_TAB",
  CONVERT_CTA: "CONVERT_CTA",
  CREATE_FIRST_CONVERSION_CTA: "CREATE_FIRST_CONVERSION_CTA",
  CUSTOM_VOICE_CTA: "CUSTOM_VOICE_CTA",
  CUSTOM_VOICE_FORM: "CUSTOM_VOICE_FORM",
  FAST_LOGIN: "FAST_LOGIN",
  FAST_SIGNUP: "FAST_SIGNUP",
  FILTER_VOICES_CANCEL: "FILTER_VOICES_CANCEL",
  FILTER_VOICES: "FILTER_VOICES",
  FINISH_TOUR_CTA: "FINISH_TOUR_CTA",
  FOLDER_DELETE_CTA: "FOLDER_DELETE_CTA",
  FOLDER_EXPORT_CTA: "FOLDER_EXPORT_CTA",
  FOLDER_RENAME: "FOLDER_RENAME",
  FOLDER_SEARCH: "FOLDER_SEARCH",
  FOLDER_SORT: "FOLDER_SORT",
  GROWTHBOOK: "GROWTHBOOK",
  HELP_RESOURCES: "HELP_RESOURCES",
  HOW_TO_ALLOW_MIC: "HOW_TO_ALLOW_MC",
  KIDS_INFO: "KIDS_INFO",
  LOGO: "LOGO",
  MIC_ALLOWED: "MIC_ALLOWED",
  MIC_FORBIDDEN: "MIC_FORBIDDEN",
  NARRATION_STYLE_CHANGE: "NARRATION_STYLE_CHANGE",
  NEW_FOLDER: "NEW_FOLDER",
  NEW_ORIGINAL: "NEW_ORIGINAL",
  NEW_PROJECT: "NEW_PROJECT",
  NEW_RECORDING_FLOW_ADD_MORE_ORIGINALS:
    "NEW_RECORDING_FLOW_ADD_MORE_ORIGINALS",
  ORIGINALS_SORT: "ORIGINALS_SORT",
  PAGE_VIEW: "PAGE_VIEW",
  PAGINATION_CONTROL: "PAGINATION_CONTROL",
  PERSONAL_SPACE: "PERSONAL_SPACE",
  PLAN_CARD_TTS_POSITION: "PLAN_CARD_TTS_POSITION",
  PLAY_AUDIO: "PLAY_AUDIO",
  PLAY_VIDEO: "PLAY_VIDEO",
  PROJECT_DELETE_CTA: "PROJECT_DELETE_CTA",
  PROJECT_EXPORT_CTA: "PROJECT_EXPORT_CTA",
  PROJECT_RENAME: "PROJECT_RENAME",
  PROJECT_SETTINGS_VIEW: "PROJECT_SETTINGS_VIEW",
  PROJECTS_SEARCH: "PROJECTS_SEARCH",
  PROJECTS_SORT: "PROJECTS_SORT",
  RECORD_AGAIN_CTA: "RECORD_AGAIN_CTA",
  RECORDING_DELETE_CTA: "RECORDING_DELETE_CTA",
  RECORDING_DOWNLOAD_SINGLE: "RECORDING_DOWNLOAD_SINGLE",
  RECORDING_INFO: "RECORDING_INFO",
  RECORDING_PLAY: "RECORDING_PLAY",
  REGENERATE_CTA: "REGENERATE_CTA",
  REQUEST_PERMISSION_CTA: "REQUEST_PERMISSION_CTA",
  REVIEW_AUP_CTA: "REVIEW_AUP_CTA",
  SELECT_VOICE: "SELECT_VOICE",
  SEMITONES_CORRECTION: "SEMITONES_CORRECTION",
  START_TOUR_CL: "START_TOUR_CL",
  START_TRIAL_CTA: "START_TRIAL_CTA",
  START_USING_CTA: "START_USING_CTA",
  STATUS_ICON: "STATUS_ICON",
  SUBMIT_FEEDBACK: "SUBMIT_FEEDBACK",
  SURVEY_NPS_OPTION: "SURVEY_NPS_OPTION",
  SURVEY_NPS_SCORE: "SURVEY_NPS_SCORE",
  THATS_ME_CTA: "THATS_ME_CTA",
  UPDATE_PLAN: "UPDATE_PLAN",
  UPDT_SAVED_VOICES_CHKB: "UPDT_SAVED_VOICES_CHKB",
  USE_LAST_SELECTED_CTA: "USE_LAST_SELECTED_CTA",
  USE_SAVED_VOICES_CHKB: "USE_SAVED_VOICES_CHKB",
  USER_PLAN_CARD: "USER_PLAN_CARD",
  VOICE_CARD_CTA: "VOICE_CARD_CTA",
  VOICE_FAVOURITE_CTA: "VOICE_FAVOURITE_CTA",
  VOICES_SEARCH: "VOICES_SEARCH",
  WELCOME_TOUR: "WELCOME_TOUR",
  WW_ADD_MORE_VOICES_CTA: "WW_ADD_MORE_VOICES_CTA",
  WW_CREATE_NEW_ORIGINAL_CTA: "WW_CREATE_NEW_ORIGINAL_CTA",
  WW_SET_TYPE: "WW_SET_TYPE",
  PRO_TOOLS_PLUGIN_LINK_CLICK: "PRO_TOOLS_PLUGIN_LINK_CLICK",
};

export const RECORDING_PLAY_PLACES = {
  project: "project",
  create_original: "create_original",
  welcome_tour: "welcome_tour",
};

export const PROJECTS_SEARCH_PLACES = {
  home: "home",
  projects_dropdown: "projects_dropdown",
};

export const PERSONAL_SPACE_OPTIONS = {
  account: "account",
  terms: "terms",
  subscription: "subscription",
  statistics: "statistics",
  logout: "logout",
};

export const HELP_RESOURCES_OPTIONS = {
  help_request: "help_request",
  feedback: "feedback",
  faq: "faq",
  help_video: "help_video",
};

export const PAGE_VIEW_FROM = {
  logo: "logo",
  back_to_project_from_voices: "back_to_project_from_voices",
  back_to_project_from_original: "back_to_project_from_original",
  back_to_calibrations: "back_to_calibrations",
  projects_dropdown: "projects_dropdown",
  calibrate_your_voice_tip: "calibrate_your_voice_tip",
  upgrade_plan: "upgrade_plan",
};

export const PROJECT_RENAME_PLACES = {
  projects_list: "projects_list",
  project_info: "project_info",
};

export const PROJECT_EXPORT_CTA_PLACES = {
  home: "home",
  project_settings: "project_settings",
};

export const FOLDER_RENAME_PLACES = {
  folders_list: "folders_list",
  header: "header",
};

export const PAGINATION_CONTROL_TYPES = {
  folder: "folder",
  project: "project",
  voices: "voices",
  calibration: "calibration",
  originals: "originals",
  conversions: "conversions",
};

export const PAGINATION_CONTROL_CONTROLS = {
  prev: "prev",
  next: "next",
  first: "first",
  last: "last",
};

export const RECORDING_DELETE_CTA_PLACES = {
  project: "project",
  create_original: "create_original",
};

export const VOICE_FAVOURITE_CTA_PLACES = {
  voice_settings: "voice_settings",
  voice_card: "voice_card",
};

export const SELECT_VOICE_PLACES = {
  voice_settings: "voice_settings",
  voice_card: "voice_card",
};

export const ACCENT_NARRATION_STYLE_CHANGE_PLACES = {
  conversion: "conversion",
  audition_voices: "audition_voices",
};

export const FAST_LOGIN_SIGNUP_OPTIONS = {
  apple: "apple",
  facebook: "facebook",
  linkedin: "linkedin",
  google: "google",
};

export const PLAY_AUDIO_PLACES = {
  home: "home",
  audition_voices: "audition_voices",
  voice_settings: "voice_settings",
  voice_card_icon: "voice_card_icon",
  voice_talent_card_icon: "voice_talent_card_icon",
};

export const PLAY_VIDEO_PLACES = {
  help_video: "help_video",
  welcome_tour: "welcome_tour",
};

export const HOW_TO_ALLOW_MIC_PLACES = {
  calibration: "calibration",
  standard_flow: "standard_flow",
  welcome_tour: "welcome_tour",
};

export const EVENTS_KEY = "_racoon";

const userAgent = navigator.userAgent;
const windowOpera = window.opera;

const browserDataParser = {
  browser(user_agent, vendor, opera) {
    vendor = vendor || ""; // vendor is undefined for at least IE9
    if (opera || user_agent.includes(" OPR/")) {
      if (user_agent.includes("Mini")) {
        return "Opera Mini";
      }
      return "Opera";
    } else if (/(BlackBerry|PlayBook|BB10)/i.test(user_agent)) {
      return "BlackBerry";
    } else if (
      user_agent.includes("IEMobile") ||
      user_agent.includes("WPDesktop")
    ) {
      return "Internet Explorer Mobile";
    } else if (user_agent.includes("SamsungBrowser/")) {
      return "Samsung Internet";
    } else if (user_agent.includes("Edge") || user_agent.includes("Edg/")) {
      return "Microsoft Edge";
    } else if (user_agent.includes("FBIOS")) {
      return "Facebook Mobile";
    } else if (user_agent.includes("Chrome")) {
      return "Chrome";
    } else if (user_agent.includes("CriOS")) {
      return "Chrome iOS";
    } else if (
      user_agent.includes("UCWEB") ||
      user_agent.includes("UCBrowser")
    ) {
      return "UC Browser";
    } else if (user_agent.includes("FxiOS")) {
      return "Firefox iOS";
    } else if (vendor.includes("Apple")) {
      if (user_agent.includes("Mobile")) {
        return "Mobile Safari";
      }
      return "Safari";
    } else if (user_agent.includes("Android")) {
      return "Android Mobile";
    } else if (user_agent.includes("Konqueror")) {
      return "Konqueror";
    } else if (user_agent.includes("Firefox")) {
      return "Firefox";
    } else if (user_agent.includes("MSIE") || user_agent.includes("Trident/")) {
      return "Internet Explorer";
    } else if (user_agent.includes("Gecko")) {
      return "Mozilla";
    } else {
      return "";
    }
  },

  /**
   * This function detects which browser version is running this script,
   * parsing major and minor version (e.g., 42.1). User agent strings from:
   * http://www.useragentstring.com/pages/useragentstring.php
   */
  browserVersion(userAgent, vendor, opera) {
    const browser = this.browser(userAgent, vendor, opera);
    const versionRegexs = {
      "Internet Explorer Mobile": /rv:(\d+(\.\d+)?)/,
      "Microsoft Edge": /Edge?\/(\d+(\.\d+)?)/,
      Chrome: /Chrome\/(\d+(\.\d+)?)/,
      "Chrome iOS": /CriOS\/(\d+(\.\d+)?)/,
      "UC Browser": /(UCBrowser|UCWEB)\/(\d+(\.\d+)?)/,
      Safari: /Version\/(\d+(\.\d+)?)/,
      "Mobile Safari": /Version\/(\d+(\.\d+)?)/,
      Opera: /(Opera|OPR)\/(\d+(\.\d+)?)/,
      Firefox: /Firefox\/(\d+(\.\d+)?)/,
      "Firefox iOS": /FxiOS\/(\d+(\.\d+)?)/,
      Konqueror: /Konqueror:(\d+(\.\d+)?)/,
      BlackBerry: /BlackBerry (\d+(\.\d+)?)/,
      "Android Mobile": /android\s(\d+(\.\d+)?)/,
      "Samsung Internet": /SamsungBrowser\/(\d+(\.\d+)?)/,
      "Internet Explorer": /(rv:|MSIE )(\d+(\.\d+)?)/,
      Mozilla: /rv:(\d+(\.\d+)?)/,
    };
    const regex = versionRegexs[browser];
    if (regex === undefined) {
      return null;
    }
    const matches = userAgent.match(regex);
    if (!matches) {
      return null;
    }
    return parseFloat(matches[matches.length - 2]);
  },

  os() {
    const a = userAgent;
    if (/Windows/i.test(a)) {
      if (/Phone/.test(a) || /WPDesktop/.test(a)) {
        return "Windows Phone";
      }
      return "Windows";
    } else if (/(iPhone|iPad|iPod)/.test(a)) {
      return "iOS";
    } else if (/Android/.test(a)) {
      return "Android";
    } else if (/(BlackBerry|PlayBook|BB10)/i.test(a)) {
      return "BlackBerry";
    } else if (/Mac/i.test(a)) {
      return "Mac OS X";
    } else if (/Linux/.test(a)) {
      return "Linux";
    } else if (/CrOS/.test(a)) {
      return "Chrome OS";
    } else {
      return "";
    }
  },

  device(user_agent) {
    if (/Windows Phone/i.test(user_agent) || /WPDesktop/.test(user_agent)) {
      return "Windows Phone";
    } else if (/iPad/.test(user_agent)) {
      return "iPad";
    } else if (/iPod/.test(user_agent)) {
      return "iPod Touch";
    } else if (/iPhone/.test(user_agent)) {
      return "iPhone";
    } else if (/(BlackBerry|PlayBook|BB10)/i.test(user_agent)) {
      return "BlackBerry";
    } else if (/Android/.test(user_agent)) {
      return "Android";
    } else {
      return "";
    }
  },

  referringDomain(referrer) {
    const split = referrer.split("/");
    if (split.length >= 3) {
      return split[2];
    }
    return "";
  },

  UUID: (function () {
    const T = () => {
      const d = 1 * +new Date();
      let i = 0;

      while (d == 1 * +new Date()) {
        i++;
      }

      return d.toString(16) + i.toString(16);
    };

    const R = () => {
      return Math.random().toString(16).replace(".", "");
    };

    const UA = () => {
      let buffer = [];
      let ret = 0;

      const xor = (result, byte_array) => {
        let tmp = 0;
        for (let j = 0; j < byte_array.length; j++) {
          tmp |= buffer[j] << (j * 8);
        }
        return result ^ tmp;
      };

      for (let i = 0; i < userAgent.length; i++) {
        buffer.unshift(userAgent.charCodeAt(i) & 0xff);
        if (buffer.length >= 4) {
          ret = xor(ret, buffer);
          buffer = [];
        }
      }

      if (buffer.length > 0) {
        ret = xor(ret, buffer);
      }

      return ret.toString(16);
    };

    return () => {
      const se = (window.innerHeight * window.innerWidth).toString(16);
      return T() + "-" + R() + "-" + UA() + "-" + se + "-" + T();
    };
  })(),
};

const eventsService = {
  trackEvents: true,
  debug: false,
  showShort: false,
  store: undefined,
  config({ user = undefined, debug = false, store = undefined }) {
    this.store = store;
    const searchParams = new URLSearchParams(document.location.search);
    const trackStaff =
      process.env.REACT_APP_EVENTS_TRACK_STAFF.toString() === "true";
    const currentUserIsStaff =
      user &&
      (user.roles.includes(USER_ROLES.ADMIN) ||
        user.email.includes("@respeecher.com"));
    this.trackEvents = trackStaff || !currentUserIsStaff;
    this.debug = debug;
    if (searchParams.has(EVENTS_KEY)) {
      localStorage.setItem(EVENTS_KEY, searchParams.get(EVENTS_KEY));
    }
    if (!localStorage.getItem(EVENTS_KEY)) {
      localStorage.setItem(EVENTS_KEY, browserDataParser.UUID());
    }
  },
  withTrackEventsCheck(func) {
    this.trackEvents && func();
  },
  getSystemProperties() {
    return {
      $os: browserDataParser.os(),
      $browser: browserDataParser.browser(
        userAgent,
        navigator.vendor,
        windowOpera
      ),
      $referrer: document.referrer,
      $referring_domain: browserDataParser.referringDomain(document.referrer),
      $device: browserDataParser.device(userAgent),
      $current_url: window.location.href,
      $browser_version: browserDataParser.browserVersion(
        userAgent,
        navigator.vendor,
        windowOpera
      ),
      $screen_height: window.innerHeight,
      $screen_width: window.innerWidth,
      time: Date.now(),
      language: navigator.language,
    };
  },
  track(event, props = {}) {
    this.withTrackEventsCheck(() => {
      const auth = (this.store || store).getState().auth;

      let properties = {
        ...this.getSystemProperties(),
        ...props,
      };

      if (auth.isAuthenticated) {
        const user = auth.user;

        properties = {
          ...properties,
          // "logged_user": true,
          // @ts-ignore
          user_id: user.id,
          user_roles: user.roles,
          user_subscription_interval:
            user.data?.stripe?.subscription_interval || null,
          user_subscription_status:
            user.data?.stripe?.subscription_status || null,
        };
      }

      api.auth.events({
        event,
        properties,
        user_id: localStorage.getItem(EVENTS_KEY),
      });

      if (this.debug) {
        logger.info(
          "sending event...",
          event,
          this.showShort ? props : properties
        );
      }
    });
  },
  viewPage(url, properties) {
    this.withTrackEventsCheck(() => {
      // TODO figure out a way to track urls
      // with and without params together
      if (url in urlsToTrack) {
        this.track(EVENTS.PAGE_VIEW, {
          ...properties,
          place: urlsToTrack[url],
        });
      }
      if (url.includes(LINKS.verifyEmail)) {
        this.track(EVENTS.PAGE_VIEW, {
          ...properties,
          place: urlsToTrack[LINKS.verifyEmail],
        });
      }
    });
  },
};

export default eventsService;
